import React, { Component } from "react";
import ModalOverlay from "components/UI/ModalOverlay";
class GalleryModal extends Component {
  style = {
    modalBody: {
      width: "900px",
      height: "500px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "5px solid rgba(0, 0, 0, 0.45)",
      backgroundColor: "rgba(78, 78, 78, 0.38)",
      position: "relative"
    },
    backgroundStyle: {},
    leftArrowWrapper: {
      display: "flex",
      alignItems: "center",
      position: "absolute",
      top: "0px",
      bottom: "0px",
      left: "10px"
    },
    rightArrowWrapper: {
      display: "flex",
      alignItems: "center",
      position: "absolute",
      top: "0px",
      bottom: "0px",
      right: "10px"
    },
    arrow: {
      height: "50px",
      width: "50px"
    },
    image: {
      maxWidth: "880px",
      maxHeight: "500px"
    },
    deleteIconWrapper: {
      position: "absolute",
      left: "0px",
      right: "0px",
      bottom: "10px",
      margin: "0px 20px"
    },
    deleteIcon: {
      height: "30px",
      width: "30px"
    }
  };
  getDragData = event => {
    console.log(event);
  };
  receiveDrag = event => {
    event.preventDefault();
    let deleteDropField = document.getElementById("GalleryDeleteDragField");
    deleteDropField.style.backgroundColor = "rgba(199, 59, 59, 0.31)";
  };
  leaveDrag = event => {
    let deleteDropField = document.getElementById("GalleryDeleteDragField");
    deleteDropField.style.backgroundColor = null;
  };
  deleteGalleryImage = event => {
    event.preventDefault();
    let deleteDropField = document.getElementById("GalleryDeleteDragField");
    deleteDropField.style.backgroundColor = null;

    this.props.deleteFn();
    this.props.next();
  };
  render() {
    return (
      <div style={this.style.wrapper}>
        <ModalOverlay
          underLayerStyle={this.style.backgroundStyle}
          noTitle
          close={this.props.close}
          bodyStyle={this.style.modalBody}
        >
          {
            <img
              onDragStart={this.getDragData}
              style={this.style.image}
              src={this.props.image}
              alt="GalleryImage"
            />
          }
          <div
            style={{
              ...this.style.arrowWrapper,
              ...this.style.leftArrowWrapper
            }}
          >
            <img
              src={require("assets/images/left-arrow.png")}
              style={this.style.arrow}
              onClick={this.props.prev}
              alt="Cover"
            />
          </div>
          <div
            style={{
              ...this.style.arrowWrapper,
              ...this.style.rightArrowWrapper
            }}
          >
            <img
              src={require("assets/images/right-arrow.png")}
              style={this.style.arrow}
              onClick={this.props.next}
              alt="Cover"
            />
          </div>
          <div
            id="GalleryDeleteDragField"
            onDrop={this.deleteGalleryImage}
            onDragLeave={this.leaveDrag}
            onDragOver={this.receiveDrag}
            style={this.style.deleteIconWrapper}
          >
            <img
              onClick={this.deleteGalleryImage}
              src={require("assets/images/waste-bin.png")}
              style={this.style.deleteIcon}
              alt="Cover"
            />
          </div>
        </ModalOverlay>
      </div>
    );
  }
}

export default GalleryModal;
